import { ApiEntity, SizeEntity, EntityId, } from "../types/index.js";
export function getRoutePath(...slugs) {
    const path = [""];
    for (const slug of slugs) {
        if (!slug)
            continue;
        if (typeof slug === "string") {
            path.push(slug);
            continue;
        }
        if (!slug.param)
            continue;
        let val = `:${slug.param}`;
        if (slug.optional)
            val = `${val}?`;
        path.push(val);
    }
    return path.join("/");
}
export function getBaseUrl(...prefix) {
    const routePath = getRoutePath(...prefix);
    function baseUrl(args) {
        const { serverUrl } = args;
        return [serverUrl, ...prefix].join("/");
    }
    baseUrl.Route = routePath;
    return baseUrl;
}
export function getBaseViewBoxUrl(...prefix) {
    const baseUrl = getBaseUrl(...prefix);
    function baseViewBoxUrl(args) {
        const { [SizeEntity.Width]: width, [SizeEntity.Height]: height } = args;
        return [baseUrl(args), width, height].join("/");
    }
    baseViewBoxUrl.Route = getRoutePath(...prefix, { param: SizeEntity.Width }, { param: SizeEntity.Height });
    return baseViewBoxUrl;
}
export function getIdUrl(requiredId, entity, ...prefix) {
    const baseUrl = getBaseUrl(...prefix, entity);
    const idKey = EntityId[entity];
    function getIdUrl(args) {
        const url = [baseUrl(args)];
        const { [idKey]: id } = args;
        id && url.push(id);
        return url.join("/");
    }
    getIdUrl.Route = getRoutePath(...prefix, entity, {
        param: idKey,
        optional: !requiredId,
    });
    return getIdUrl;
}
export function getIdViewBoxUrl(requiredId, entity, ...prefix) {
    const baseViewBoxUrl = getBaseViewBoxUrl(...prefix);
    const idKey = EntityId[entity];
    function getIdViewBoxUrl(args) {
        const url = [baseViewBoxUrl(args), entity];
        const { [idKey]: id } = args;
        id && url.push(id);
        return url.join("/");
    }
    getIdViewBoxUrl.Route = getRoutePath(...prefix, { param: SizeEntity.Width }, { param: SizeEntity.Height }, entity, {
        param: idKey,
        optional: !requiredId,
    });
    return getIdViewBoxUrl;
}
export class SearchBaseUrl {
    Items;
    Count;
    constructor(entity) {
        this.Items = getBaseUrl(ApiEntity.Search, entity);
        this.Count = getBaseUrl(ApiEntity.Search, ApiEntity.Count, entity);
    }
}
export class SearchFeatureUrl extends SearchBaseUrl {
    Feature;
    constructor(requiredId, entity) {
        super(entity);
        this.Feature = {
            Items: getIdUrl(requiredId, entity, ApiEntity.Search, ApiEntity.Feature),
            Count: getIdUrl(requiredId, entity, ApiEntity.Search, ApiEntity.Count, ApiEntity.Feature),
        };
    }
}
export class SearchViewBoxUrl extends SearchFeatureUrl {
    ViewBox;
    constructor(requiredId, entity) {
        super(requiredId, entity);
        this.ViewBox = {
            Items: getIdViewBoxUrl(requiredId, entity, ApiEntity.Search, ApiEntity.Feature),
            Count: getIdViewBoxUrl(requiredId, entity, ApiEntity.Search, ApiEntity.Count, ApiEntity.Feature),
        };
    }
}
